import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Sale1010GetResultModel, Sale1010GetResultSchema } from './get.schema'

export async function fetchSale1010(
  id: number
): Promise<Sale1010GetResultModel> {
  const response = await axios.get<Sale1010GetResultModel>(
    `/api/sale/sale1010/${id}`
  )
  return Sale1010GetResultSchema.parse(response.data)
}

export const getSale1010ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['sale1010', id],
    queryFn: () => fetchSale1010(id),
  })
